import React, { useState, useContext } from "react";
import ContactForm from "../ContactForm/ContactForm";
import { FormContext } from "../../App";
import "./index.scss";

const Navbar = () => {
  const { formOpen, setFormOpen } = useContext(FormContext);

  return (
    <>
      <ContactForm />

      <nav className="navbar">
        <div className="name">.ZIYA</div>
        <div className="more" onClick={() => setFormOpen(!formOpen)}>
          <svg
            width="27"
            height="25"
            viewBox="0 0 27 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.63988 8.69565C7.20242 8.69565 9.27976 6.74906 9.27976 4.34783C9.27976 1.94659 7.20242 0 4.63988 0C2.07735 0 0 1.94659 0 4.34783C0 6.74906 2.07735 8.69565 4.63988 8.69565Z"
              fill="#E6015C"
            />
            <path
              d="M4.63988 25C7.20242 25 9.27976 23.0534 9.27976 20.6522C9.27976 18.251 7.20242 16.3044 4.63988 16.3044C2.07735 16.3044 0 18.251 0 20.6522C0 23.0534 2.07735 25 4.63988 25Z"
              fill="#E6015C"
            />
            <path
              d="M22.0394 8.69565C24.602 8.69565 26.6793 6.74906 26.6793 4.34783C26.6793 1.94659 24.602 0 22.0394 0C19.4769 0 17.3995 1.94659 17.3995 4.34783C17.3995 6.74906 19.4769 8.69565 22.0394 8.69565Z"
              fill="#E6015C"
            />
            <path
              d="M22.0394 25C24.602 25 26.6793 23.0534 26.6793 20.6522C26.6793 18.251 24.602 16.3044 22.0394 16.3044C19.4769 16.3044 17.3995 18.251 17.3995 20.6522C17.3995 23.0534 19.4769 25 22.0394 25Z"
              fill="#E6015C"
            />
          </svg>

          <div className="moreText">Get in touch</div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
